import { allocatedSolarElectrical } from './solarElectricalTopology';
import { type SolarDesignDraftState } from './solarDesignDraft';

export type SolarDesignRestoreReason = 'history' | 'remote';

/** History restores profiles, not declarations made against a different revision. */
export const restoreSolarDesignHistory = (
  current: SolarDesignDraftState,
  restored: SolarDesignDraftState,
  reason: SolarDesignRestoreReason
): { state: SolarDesignDraftState; clearedInstanceIds: string[] } => {
  const state = structuredClone(restored);
  const clearedInstanceIds: string[] = [];
  const topology = allocatedSolarElectrical(state.electrical);
  if (reason === 'history' && topology) {
    for (const instance of topology.inverterInstances) {
      const previous = allocatedSolarElectrical(
        current.electrical
      )?.inverterInstances.find((item) => item.id === instance.id);
      if (
        !previous ||
        previous.equipmentSelectionId === instance.equipmentSelectionId
      )
        continue;
      instance.trackers = [];
      for (const string of topology.strings) {
        if (string.inverterInstanceId !== instance.id) continue;
        string.inverterInstanceId = null;
        string.mpptKey = null;
        string.inputKey = null;
      }
      clearedInstanceIds.push(instance.id);
    }
    if (clearedInstanceIds.length) topology.validation = null;
  }
  return { state, clearedInstanceIds };
};
